import { Model } from '@nozbe/watermelondb'
import { field, date, readonly, relation } from '@nozbe/watermelondb/decorators'

export default class UserInvitation extends Model {
    static table = 'user_invitations'
    static associations = {
        merchants: { type: 'belongs_to' as const, key: 'merchant_id' },
        stores: { type: 'belongs_to' as const, key: 'store_id' },
        users: { type: 'belongs_to' as const, key: 'invited_by_id' },
    }

    @field('merchant_id') merchantId!: string
    @field('store_id') storeId!: string
    @field('phone') phone!: string
    @field('name') name!: string | null
    @field('role') role!: string
    @field('permissions') permissions!: string | null
    @field('status') status!: string
    @field('invited_by_id') invitedById!: string
    @date('expires_at') expiresAt!: Date | null
    @field('requires_approval') requiresApproval!: boolean
    @field('version') version!: number
    @field('is_synced') isSynced!: boolean
    @field('is_deleted') isDeleted!: boolean
    @readonly @date('created_at') createdAt!: Date
    @readonly @date('updated_at') updatedAt!: Date

    @relation('merchants', 'merchant_id') merchant: any
    @relation('stores', 'store_id') store: any
    @relation('users', 'invited_by_id') invitedBy: any
}
